interface FAQItem {
  q: string;
  a: string;
}

interface FAQProps {
  eyebrow?: string;
  heading?: string;
  items: FAQItem[];
}

const FAQ = ({
  eyebrow = "Frequently asked questions",
  heading = "Answers to common questions",
  items,
}: FAQProps) => {
  return (
    <section
      aria-labelledby="faq-heading"
      className="py-20 lg:py-28 bg-secondary/40 border-y border-border"
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-3xl mb-10">
          <p className="text-accent font-semibold text-sm uppercase tracking-widest mb-4">
            {eyebrow}
          </p>
          <h2
            id="faq-heading"
            className="font-display text-3xl lg:text-4xl font-bold text-foreground"
          >
            {heading}
          </h2>
        </div>
        <dl className="max-w-3xl space-y-6">
          {items.map(({ q, a }) => (
            <div
              key={q}
              className="bg-card border border-border rounded-lg p-6"
            >
              <dt className="font-display font-semibold text-lg text-foreground mb-2">
                {q}
              </dt>
              <dd className="text-muted-foreground leading-relaxed">{a}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};

export default FAQ;
